import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function NoteModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    text: Yup.string().required("This field is required!"),
  });

  return (
    <Fragment>
      {modal.name === "note_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>
                {modal.mode === "edit" ? "Edit" : "Create"} Note
              </div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  text: modal.data && modal.data.text ? modal.data.text : "",
                }}
                onSubmit={async (values) => {
                  setLoading(true);

                  if (modal.mode === "edit") {
                    await axios
                      .patch(`/api/note/${modal.data.id}`, {
                        text: values.text,
                      })
                      .then((r) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          "Note updated!",
                          "success",
                          true,
                          "toast",
                          "check-circle"
                        );

                        modal.action();
                      })
                      .catch((error) => {
                        console.log(error);

                        setLoading(false);
                        setModal({});
                      });
                  } else {
                    await axios
                      .post("/api/note", {
                        text: values.text,
                        account_id: modal.agency_id,
                      })
                      .then((r) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          "Note created!",
                          "success",
                          true,
                          "toast",
                          "check-circle"
                        );

                        modal.action();
                      })
                      .catch((error) => {
                        console.log(error);

                        setLoading(false);
                        setModal({});
                      });
                  }
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div
                        className={styles.fieldRow}
                        style={{ paddingBottom: 0 }}
                      >
                        <FieldInput
                          id="text"
                          type="text"
                          label="Note"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          showErrors
                          errors={errors.text}
                          touched={touched.text}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            <>{modal.mode === "edit" ? "Update" : "Create"}</>
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
